





















































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';

import { appName } from '@/env';
import {
  dispatchGetOmrTaskList,
  dispatchGetXmlScore,
  dispatchGetUploadImageList,
  readUploadImageList,
} from '@/store/omr/vuex';
import { OmrTaskState } from '@/store/omr/state';
import router from '@/router';
import { dispatchPatchOmrTask, dispatchUpdateOmrTask } from '@/store/omr/actions';
import { commitAddNotification } from '@/store/main/mutations';
import ListRating from './components/ListRating.vue';

const routeGuardMain = async (to, from, next) => {
  if (to.path === '/omr') {
    // next('/main/dashboard');
    router.push('/omr/upload');
  } else {
    next();
  }
};

@Component({
  components: {
    ListRating,
  },
})
export default class OmrRouterView extends Vue {
  public appName = appName;

  public dialog = false;
  public dialogDelete = false;
  public refreshDisabled = false;
  public updateClickCnt = 0;
  public updateClickTime = Date.now();
  public recalculateDialog = false;
  public ratingFeedbackDialog = false;
  public errorFeedbackSelect = 0;
  public errorFeedbackDesc = '';

  public errorFeedbackSelectList = [
    {
      icon: 'mdi-emoticon-cool-outline',
      text: '完全正确 Exactly right',
    },
    {
      icon: 'mdi-music-circle',
      text: '几个音符不对 Some wrong notes',
    },
    {
      icon: 'mdi-numeric-5-circle',
      text: '1-5个小节不对 1-5 section errors',
    },
    {
      icon: 'mdi-numeric-10-circle',
      text: '6-10个小节不对 6-10 section errors',
    },
    {
      icon: 'mdi-emoticon-cry-outline',
      text: '11个以上小节不对 More than 11 sections errors',
    },
  ];

  public headers = [
    {
      text: '曲目名称 Score Name',
      align: 'start',
      sortable: false,
      value: 'score_name',
    },
    { text: '状态 State', value: 'state' },
    { text: '创建时间 Create Time', value: 'create_time' },
    { text: '评分 Rating', value: 'rating' },
    { text: '操作 Actions', value: 'actions', sortable: false },
  ];

  public desserts: OmrTaskState[] = [];
  public editedIndex = -1;
  public editedItem: OmrTaskState = {
    score_name: '',
    state: '',
    create_time: new Date(),
  };

  public defaultItem: OmrTaskState = {
    score_name: '',
    state: '',
    create_time: new Date(),
    task_id: '',
    music_id: '',
    rating: 5,
    feedback: '',
  };

  // score display
  public baseIframeMusicScoreSrc: string = 'https://www.aitanzou.com/analysis/v16_chatwebview/sheet.html?music_id=';
  public iframeMusicScoreHeight: string = window.innerHeight * 0.72 + 'px';
  public musicId: string = '';
  public dialogDisplayScore: boolean = false;
  public viewedItem: OmrTaskState = {
    score_name: '',
    state: '',
    create_time: new Date(),
    rating: 5,
    feedback: '',
  };

  // raw img display
  public previewImgs: string[] = [];
  public activeShowImg: boolean = false;

  public randomInt() {
    return Math.floor(Math.random() * 5) + 1;
  }

  get formTitle() {
    return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
  }

  @Watch('dialog')
  public watchDialog(val) {
    return val || this.close();
  }

  @Watch('dialogDelete')
  public watchDialogDelete(val) {
    return val || this.closeDelete();
  }

  @Watch('dialogDisplayScore')
  public wathcDialogDisplayScore(val) {
    return val || this.closeDisplayScore();
  }

  public created() {
    this.initialize();
  }

  public async initialize() {
    this.refreshDisabled = true;
    this.desserts = [
      {
        score_name: '样板曲目名称',
        state: '转换中',
        create_time: new Date(),
      },
    ];
    this.desserts = (await dispatchGetOmrTaskList(this.$store))?.map((v) => {
      v.create_time = new Date(v.create_time?.toString() ?? '');
      v.rating = v.rating ?? 5; // FOR MOCK TEST // this.randomInt(); 
      v.rating = v.state !== 'A' ? -1 : v.rating;
      v.rating = v.state === 'E' ? 0 : v.rating;
      return v;
    }) ?? [
      {
        score_name: '样板曲目名称，由于服务器响应故障，请稍后重试',
        state: '获取任务队列中',
        create_time: new Date(),
        rating: 5,
        feedback: '',
      },
    ];
    const that = this;
    setTimeout(() => {
      that.refreshDisabled = false;
    }, 2000);
  }

  public getColor(state: string) {
    if (state === 'A') {
      return 'green';
    } else if (state === 'E') {
      return 'red';
    } else {
      return 'orange';
    }
  }

  public getDesc(state: string) {
    if (state === 'A') {
      return '转换成功';
    } else if (state === '1') {
      return '转换中';
    } else if (state === '3') {
      return '渲染中';
    } else {
      return '超时,请重新提交';
    }
  }

  get dialogDisplayScoreWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return '100%';
      case 'sm': return '80%';
      case 'md': return '80%';
      case 'lg': return this.activeShowImg ? 1000 : 600;
      case 'xl': return this.activeShowImg ? 1200 : 600;
      default: return '80%';
    }
  }

  get screenTooSmall() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return true;
      case 'sm': return true;
      default: return false;
    }
  }

  public async recalculateItem() {
    const item = this.viewedItem;
    this.updateClickCnt += 1;
    const id = item.id;
    const duration = Date.now() - this.updateClickTime;
    console.log(duration);
    if (duration < 800) { // 1s 防快速点击
      commitAddNotification(this.$store, { content: '请不要连续点击', color: 'warning' });
      return;
    }
    if (duration > 1000 * 3) { // 3s 防刷
      this.updateClickTime = Date.now();
      this.updateClickCnt = 0;
    }
    if (this.updateClickCnt >= 5) {
      commitAddNotification(this.$store, { content: '3s内只能点5次', color: 'warning' });
      return;
    }
    if (id) {
      await dispatchUpdateOmrTask(this.$store, { id });
      item.task_id = '';
    }
    setTimeout(() => {
      this.initialize();
    }, 500)
  }

  public viewItem(item) {
    this.editedIndex = this.desserts.indexOf(item);
    const selectedItem: OmrTaskState = Object.assign({}, item);
    this.viewedItem = selectedItem;
    // window.alert(selectedItem.id);
    this.musicId = selectedItem.music_id ?? '';
    this.dialogDisplayScore = true;
  }

  get iframeMusicScoreSrc() {
    return this.baseIframeMusicScoreSrc + this.musicId;
  }

  public ratingIt() {
    this.errorFeedbackSelect = 5 - (this.viewedItem.rating ?? 0);
    this.errorFeedbackDesc = this.viewedItem?.feedback ?? '';
    this.ratingFeedbackDialog = true;
  }

  public cancelRatingFeedback() {
    this.errorFeedbackSelect = 0;
    this.errorFeedbackDesc = '';
    this.ratingFeedbackDialog = false;
  }

  public async confirmRatingFeedback() {
    const rating = 5 - this.errorFeedbackSelect;
    const feedback = this.errorFeedbackDesc;
    // TODO 发送真实数据
    await dispatchPatchOmrTask(this.$store, { id: this.viewedItem.id, rating, feedback });
    this.viewedItem.rating = rating;
    this.viewedItem.feedback = feedback;
    Object.assign(this.desserts[this.editedIndex], this.viewedItem);
    this.errorFeedbackSelect = 0;
    this.errorFeedbackDesc = '';
    this.ratingFeedbackDialog = false;
  }

  public async switchUploadImageScore() {
    if (this.activeShowImg === false) {
      await this.getUploadImageScoreDetail();
      this.activeShowImg = true;
      return;
    }
    this.activeShowImg = false;
    this.previewImgs = [];
  }

  public async getUploadImageScoreDetail() {
    if (this.previewImgs.length > 0) {
      return;
    }
    const id = this.viewedItem.id;
    if (!id) {
      return;
    }
    await dispatchGetUploadImageList(this.$store, { id });
    this.previewImgs = readUploadImageList(this.$store);
  }

  get showDisplayScore() {
    const canShowDisplayScore = this.musicId !== '';
    if (this.screenTooSmall) {
      return !this.activeShowImg && canShowDisplayScore;
    } else {
      return canShowDisplayScore;
    }
  }

  get showImg() {
    const canShowImg = this.previewImgs.length > 0;
    if (this.screenTooSmall) {
      // 屏幕过小，只激活时显示
      return this.activeShowImg;
    } else {
      // 屏幕够大 能显示就显示
      return canShowImg;
    }
  }

  public closeDisplayScore() {
    this.dialogDisplayScore = false;
    this.$nextTick(() => {
      this.viewedItem = Object.assign({}, this.defaultItem);
      this.activeShowImg = false;
      this.previewImgs = [];
      this.musicId = '';
      this.editedIndex = -1;
    });
  }

// 下载曲谱
  public actionDownloadXmlScore() {
    const musicId = this.viewedItem.music_id;
    const scoreName = this.viewedItem.score_name;
    if (!musicId) {
      return;
    }
    const transUUID = this.viewedItem.id;
    if (!transUUID) {
      return;
    }
    dispatchGetXmlScore(this.$store, { transUUID }).then((response) => {
      const filename = response.headers['content-disposition'];
      console.log(filename);
      const blob = new Blob([response.data]);
      const downloadElement = document.createElement('a');
      const href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      const xmlFilename = (scoreName + '.musicxml' || filename?.split('filename=')[1] || '未知曲谱.musicxml');
      downloadElement.download = decodeURIComponent(xmlFilename);
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(href);
      // this.trans_uuid = '';
    });
  }

  public editItem(item) {
    this.editedIndex = this.desserts.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  public deleteItem(item) {
    this.editedIndex = this.desserts.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialogDelete = true;
  }

  public deleteItemConfirm() {
    this.desserts.splice(this.editedIndex, 1);
    this.closeDelete();
  }

  public close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  public closeDelete() {
    this.dialogDelete = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  public save() {
    if (this.editedIndex > -1) {
      Object.assign(this.desserts[this.editedIndex], this.editedItem);
    } else {
      this.desserts.push(this.editedItem);
    }
    this.close();
  }

}
